import React from "react";
import { ILeadUser } from "../../models/LeadData.model";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface AssigneeIconProps {
  assignee?: ILeadUser;
  onClick: () => void;
}

const AssigneeIcon: React.FC<AssigneeIconProps> = ({ assignee, onClick }) => {
  const userId = useSelector((state: RootState) => state.auth.userId);

  return (
    <div className="relative inline-block group">
      <span
        className="peer flex items-center gap-1 cursor-pointer rounded-full text-gray-700 shadow-md px-2 py-1 transition-all duration-300"
        onClick={onClick}
      >
        <span
          className={
            assignee?._id === userId ? "text-green-500" : "text-gray-50"
          }
        >
          ●
        </span>
        {/* Compact SVG Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          width="16px"
          height="16px"
          fill="currentColor"
        >
          <path d="M 8 2 C 6.347656 2 5 3.347656 5 5 C 5 6.652344 6.347656 8 8 8 C 9.652344 8 11 6.652344 11 5 C 11 3.347656 9.652344 2 8 2 Z M 8 8 C 5.246094 8 3 10.246094 3 13 L 4 13 C 4 10.785156 5.785156 9 8 9 C 10.214844 9 12 10.785156 12 13 L 13 13 C 13 10.246094 10.753906 8 8 8 Z M 8 3 C 9.109375 3 10 3.890625 10 5 C 10 6.109375 9.109375 7 8 7 C 6.890625 7 6 6.109375 6 5 C 6 3.890625 6.890625 3 8 3 Z" />
        </svg>

        {/* Compact Assignee Name */}
        <p className="text-xs font-medium">
          {assignee?.username?.substring(0, 2)?.toUpperCase()}
        </p>
      </span>

      {assignee?.username && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 peer-hover:opacity-100 transition-opacity pointer-events-none">
          {assignee.username}
        </div>
      )}
    </div>
  );
};

export default AssigneeIcon;
